/*!
 * rr-combined-listing-remount.js — DM CL — 2026-08-11
 *
 * PROBLEMA
 * El selector de color de algunos productos (ej. 1460 Smooth) es un Combined Listing
 * de Shopify: cada color es un PRODUCTO distinto. Al elegir otro color el theme
 * reemplaza el DOM del producto sin recargar la página. Los app blocks SÍ se
 * re-renderizan con los datos nuevos, pero los widgets de terceros quedan muertos:
 *
 *   · Venti  → su <script> de init vive dentro del app block y (a) los scripts
 *              insertados vía DOM no se ejecutan, y (b) está envuelto en
 *              DOMContentLoaded, que ya disparó. Queda el contenedor vacío.
 *   · Reseñas Klaviyo → el contenedor #fulfilled-reviews-all se re-renderiza vacío
 *              con el data-id nuevo, pero el bundle de reseñas ya corrió y no
 *              vuelve a hidratarlo.
 *
 * Resultado para el cliente: al cambiar de color desaparecen las estrellas y el
 * mensaje de cuotas, justo en el momento de decidir.
 *
 * POR QUÉ UN MutationObserver Y NO EL EVENTO
 * `variant:selected` sí llega a document, pero dispara en el instante del click,
 * ANTES de que el theme reemplace el DOM: re-montar ahí llega demasiado temprano
 * y el swap posterior lo pisa. Se observa el DOM real y se actúa cuando el
 * contenedor nuevo ya está puesto y quieto.
 *
 * Nota: se reinyectan sólo runtime + vendors~reviews + reviews de Klaviyo.
 * NO se toca signup_forms a propósito: reinyectarlo volvería a mostrar el popup
 * en cada cambio de color.
 */
(function () {
  'use strict';

  var idVisto = null;      // último producto observado en el DOM
  var idRemontado = null;  // último producto ya re-montado (evita repetir)
  var timer = null;

  function idActual() {
    var v = document.querySelector('[id^="_ventipay_wdgt_"]');
    if (v) return v.id.replace('_ventipay_wdgt_', '');
    var r = document.querySelector('#fulfilled-reviews-all');
    return r ? r.getAttribute('data-id') : null;
  }

  /* Re-ejecuta los <script> inline de un contenedor.
     Los scripts que llegan por reemplazo de DOM no corren solos, y muchos apps
     envuelven su init en DOMContentLoaded: se shimea para que corra al instante. */
  function reEjecutarInline(root) {
    var addOriginal = document.addEventListener;
    document.addEventListener = function (tipo, cb) {
      if (tipo === 'DOMContentLoaded') {
        try {
          if (typeof cb === 'function') { cb(); }
          else if (cb && typeof cb.handleEvent === 'function') { cb.handleEvent(); }
        } catch (e) { /* un app no debe romper la página */ }
        return;
      }
      return addOriginal.apply(this, arguments);
    };
    try {
      var scripts = root.querySelectorAll('script:not([src])');
      for (var i = 0; i < scripts.length; i++) {
        var viejo = scripts[i];
        if (viejo.getAttribute('data-rr-remount') === '1') continue;
        viejo.setAttribute('data-rr-remount', '1');
        var nuevo = document.createElement('script');
        if (viejo.type) nuevo.type = viejo.type;
        nuevo.textContent = viejo.textContent;
        viejo.parentNode.insertBefore(nuevo, viejo.nextSibling);
      }
    } finally {
      document.addEventListener = addOriginal;
    }
  }

  function remontarVenti() {
    var v = document.querySelector('[id^="_ventipay_wdgt_"]');
    if (!v || v.children.length > 0) return; // ya montado
    var bloques = document.querySelectorAll('.shopify-app-block[id*="venti" i]');
    for (var i = 0; i < bloques.length; i++) reEjecutarInline(bloques[i]);
  }

  function remontarResenas() {
    var cont = document.querySelector('#fulfilled-reviews-all');
    if (!cont || cont.querySelectorAll('*').length > 0) return; // ya hidratado

    var urls = [];
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      if (/\/(runtime|vendors~reviews|reviews)\.[a-f0-9]+\.js/i.test(src) && urls.indexOf(src) === -1) {
        urls.push(src);
      }
    }
    if (!urls.length) return;
    // el runtime primero: resetea el registro de módulos de webpack
    urls.sort(function (a, b) {
      return (/runtime/.test(b) ? 1 : 0) - (/runtime/.test(a) ? 1 : 0);
    });
    urls.forEach(function (u) {
      var s = document.createElement('script');
      s.src = u;
      s.async = false; // preservar el orden de ejecución
      document.body.appendChild(s);
    });
  }

  /* Se llama en cada mutación; el debounce hace que corra 700 ms después de que
     el DOM dejó de moverse, o sea con el swap ya terminado. */
  function revisar() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var id = idActual();
      if (!id) return;
      if (idVisto === null) { idVisto = id; return; }  // primera lectura: sólo registrar
      if (id === idVisto) return;                      // sin cambio de producto
      idVisto = id;
      if (id === idRemontado) return;                  // ya re-montado para este producto
      idRemontado = id;
      try { remontarVenti(); } catch (e) {}
      try { remontarResenas(); } catch (e) {}
    }, 700);
  }

  function iniciar() {
    idVisto = idActual();
    if (window.MutationObserver) {
      new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
    }
    // refuerzos por si el theme cambia de mecanismo
    document.addEventListener('variant:selected', revisar, true);
    window.addEventListener('locationchange', revisar);
    window.addEventListener('popstate', revisar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
